{
  "Account Number": "Account Number",
  "Address search: {{errorMessage}}": "Address search: {{errorMessage}}",
  "Apt, suite, etc. (optional)": "Apt, suite, etc. (optional)",
  "Authorized User First and Last Name": "Authorized User First and Last Name",
  "Business Information": "Business Information",
  "Business Name": "Business Name",
  "Can't be more than 16 characters": "Can't be more than 16 characters",
  "City": "City",
  "Country": "Country",
  "Current Phone Provider": "Current Phone Provider",
  "Error searching address": "Error searching address",
  "Must be alphanumeric": "Must be alphanumeric",
  "Must be at least 3 characters": "Must be at least 3 characters",
  "Must include first and last name": "Must include first and last name",
  "Office Contact Email": "Office Contact Email",
  "PIN": "PIN",
  "Phone Provider Information": "Phone Provider Information",
  "Please add your Point of Contact Email": "Please add your Point of Contact Email",
  "Postal": "Postal",
  "Select or enter an address": "Select or enter an address",
  "Service Address": "Service Address",
  "State": "State",
  "Street Address": "Street Address",
  "This information is correct": "This information is correct",
  "e.g. \"Ste 42\", \"Apt 42\" - not \"Apt42\" or \"Ste42\".": "e.g. \"Ste 42\", \"Apt 42\" - not \"Apt42\" or \"Ste42\"."
}
